import React from 'react';
import {ServerComponentCaller} from "../../helpers";

const LicenciaClaseB = props => <ServerComponentCaller url={"assets/data/pages/licencias/B.json"}/>;

export default LicenciaClaseB;
